
import { Vue, Component } from 'vue-property-decorator';
import IconLogo from '../../assets/icon/icon-logo.svg';

@Component({
    components: {
        IconLogo
    }
})
export default class Logo extends Vue { }
